import type { ScheduledQuestion } from '@/common/api/models';

export type TopicGroup = {
  conceptKey: string;
  label: string;
  questions: ScheduledQuestion[];
};

export function groupQuestionsByTopic(
  questions: ScheduledQuestion[],
  otherLabel: string,
): TopicGroup[] {
  const order: string[] = [];
  const buckets = new Map<string, ScheduledQuestion[]>();

  questions.forEach((row) => {
    const concept = row.question?.concept?.trim() || '';
    const key = concept || '__other__';
    if (!buckets.has(key)) {
      buckets.set(key, []);
      order.push(key);
    }
    buckets.get(key)?.push(row);
  });

  return order.map((key) => ({
    conceptKey: key,
    label: key === '__other__' ? otherLabel : key,
    questions: buckets.get(key) ?? [],
  }));
}
